import Button from '@material-ui/core/Button';
import * as React from 'react';
import { Typography, FormControl, InputLabel, Input, Link } from '@material-ui/core';
import { LoginEnum } from 'src/constants/Enum/LoginEnum';
import { forgotPasswordCall } from 'src/effects/api/api.userAuth';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ReCAPTCHA from "react-google-recaptcha";
import { VERIFY_CAPTCHA_MESSAGE } from 'src/constants/NotificationMessageConstant';

export default class ForgotPasswordComponent extends React.Component<any, any> {

    state = {
        email: '',
        error: undefined,
        isClientCaptchaVerified: false,
        showClientCaptchaNotVerifiedMessage: false
    }
    constructor(props: any) {
        super(props);
        this.handleResetPassword = this.handleResetPassword.bind(this);
        this.handleGotoLogin = this.handleGotoLogin.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
    }

    handleGotoLogin = () => {
        this.props.handleComponentRendering(LoginEnum.Login);
    }
    
    handleResetPassword = () => {
        this.setState({ error: undefined });
        if (this.state.isClientCaptchaVerified && this.props.isCaptchaVerified) {
            if (this.state.email) {
                if (this.validateEmail(this.state.email)) {
                    forgotPasswordCall(this.state.email).then((res: any) => {
                        if (res.data && res.data.payload && res.data.payload) {
                            this.props.handleComponentRendering(LoginEnum.EmailLinkSuccess);
                        }
                    });
                }
                else {
                    this.setState({ error: 'Incorrect email format' });
                }
            }
            else{
                this.setState({error: 'Please enter valid email address.'})
            }
        }
        else {
            this.setState({ showClientCaptchaNotVerifiedMessage: true });
        }
    }

    handleEmail = (e: any) => {
        this.setState({ error: undefined });         
        if (e.target.value) {
            this.setState({ email: e.target.value })
        }
        else {
            this.setState({ error: 'Email id must be filled.' });
        }
    }

    validateEmail(email: any) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    onCaptchaChange(value: any) {
        // console.log("Captcha Token:", value);        
        if (value) {
            // this.setState({ successMessage: "" });
            this.setState({ showClientCaptchaNotVerifiedMessage: false });
            this.setState ({ isClientCaptchaVerified : true });
            this.props.verifyCaptcha(value);
        }
        else {
            this.setState ({ isClientCaptchaVerified : false });
        }      
    }

    render() {
        return (
            <>
                <div className="loginTitleSection">
                    <Typography component="h4" variant="title" align="center" gutterBottom={true} className="registerTitle">
                        Forgot Password?
                    </Typography>
                </div>

                <div className="loginContentSection">
                    <div className="loginText-l">
                        <span>Don't Worry!</span>
                        <span>It happens to even the best of us!</span>
                    </div>

                    <div className="loginText-s">
                        Please provide us with your registered email we will send you the password reset link
                    </div>

                    <form className="loginForm" autoComplete="off">
                    {
                        this.state.error && (
                             <span className="errorMessage">{this.state.error}</span>
                        )
                    }
                        <FormControl margin="normal" required={true} fullWidth={true} className="formControl">
                            <InputLabel htmlFor="email">Registered email ID</InputLabel>

                            <Input id="email" name="email" autoComplete="email" autoFocus={true} onChange={this.handleEmail} />
                        </FormControl>
                    </form>
                    <br />
                    <div className="captcha-wrapper">
                        <ReCAPTCHA
                            sitekey={this.props.appSettings && this.props.appSettings.googleCaptchaSitetKey}
                            onChange={this.onCaptchaChange}
                        />
                        {this.state.showClientCaptchaNotVerifiedMessage && <span className="errorMessage">{VERIFY_CAPTCHA_MESSAGE}</span>}
                    </div>  
                    <Button
                        type="submit"
                        fullWidth={true}
                        variant="contained"
                        color="primary"
                        className="btn-black"
                        onClick={this.handleResetPassword}
                    >
                        Send Link <ChevronRightIcon  className="ChevronRightIcon"/>
                    </Button>

                    <Link className="loginGoToLink" href="javascript:void(0)" onClick={this.handleGotoLogin}>Go to Login</Link>
                </div>


            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/login/forgotPassword/ForgotPasswordComponent.tsx